"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyScheduleInteractor = void 0;
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
require("./components/DailySchedulePanel");
require("./components/MonthlySchedulePanel");
require("./components/WeeklySchedulePanel");
require("./components/YearlySchedulePanel");
const DailyScheduleHarmonizationManager_1 = require("./DailyScheduleHarmonizationManager");
const DailyScheduleInfoItemsCreator_1 = require("./DailyScheduleInfoItemsCreator");
const DailyScheduleModelsConverter_1 = require("./DailyScheduleModelsConverter");
require("./models");
const MonthlyScheduleHarmonizationManager_1 = require("./MonthlyScheduleHarmonizationManager");
const MonthlyScheduleInfoItemsCreator_1 = require("./MonthlyScheduleInfoItemsCreator");
const MonthlyScheduleModelsConverter_1 = require("./MonthlyScheduleModelsConverter");
require("./types");
const WeeklyScheduleHarmonizationManager_1 = require("./WeeklyScheduleHarmonizationManager");
const WeeklyScheduleInfoItemsCreator_1 = require("./WeeklyScheduleInfoItemsCreator");
const WeeklyScheduleModelsConverter_1 = require("./WeeklyScheduleModelsConverter");
const YearlyScheduleHarmonizationManager_1 = require("./YearlyScheduleHarmonizationManager");
const YearlyScheduleInfoItemsCreator_1 = require("./YearlyScheduleInfoItemsCreator");
const YearlyScheduleModelsConverter_1 = require("./YearlyScheduleModelsConverter");
class PolicyScheduleInteractor extends core_1.Interactor {
    constructor(dailyScheduleModel, weeklyScheduleModel, monthlyScheduleModel, yearlyScheduleModel, params, texts, dailyRetentionFieldsSettings, weeklyRetentionFieldsSettings, monthlyRetentionFieldsSettings, yearlyRetentionFieldsSettings, labels, panelActions) {
        super();
        this.dailyScheduleModel = dailyScheduleModel;
        this.weeklyScheduleModel = weeklyScheduleModel;
        this.monthlyScheduleModel = monthlyScheduleModel;
        this.yearlyScheduleModel = yearlyScheduleModel;
        this.params = params;
        this.texts = texts;
        this.dailyRetentionFieldsSettings = dailyRetentionFieldsSettings;
        this.weeklyRetentionFieldsSettings = weeklyRetentionFieldsSettings;
        this.monthlyRetentionFieldsSettings = monthlyRetentionFieldsSettings;
        this.yearlyRetentionFieldsSettings = yearlyRetentionFieldsSettings;
        this.labels = labels;
        this.panelActions = panelActions;
        this.subscriptions = new rxjs_1.Subscription();
        this.getDailyScheduleInfoItems = (repositoryName) => {
            return this.dailyScheduleInfoItemsCreator.getScheduleInfoItems(repositoryName);
        };
        this.getWeeklyScheduleInfoItems = (repositoryName) => {
            return this.weeklyScheduleInfoItemsCreator.getScheduleInfoItems(repositoryName);
        };
        this.getMonthlyScheduleInfoItems = (isArchivable, thirdRowRepositoryName, archivedThirdRowRepositoryName, archivedThirdRowRepositoryStorageClass) => {
            return this.monthlyScheduleInfoItemsCreator.getScheduleInfoItems(isArchivable, thirdRowRepositoryName, archivedThirdRowRepositoryName, archivedThirdRowRepositoryStorageClass);
        };
        this.getYearlyScheduleInfoItems = (isRowThirdEnabled, isArchivable, isArchived, thirdRowRepositoryName, archivedThirdRowRepositoryName, archivedThirdRowRepositoryStorageClass) => {
            return this.yearlyScheduleInfoItemsCreator.getScheduleInfoItems(isRowThirdEnabled, isArchivable, isArchived, thirdRowRepositoryName, archivedThirdRowRepositoryName, archivedThirdRowRepositoryStorageClass);
        };
        this.handlePanelCancel = (scheduleModel, panelActions) => {
            const scheduleModelValue = scheduleModel.getValue();
            if (scheduleModelValue.isModified) {
                panelActions.hide();
                return;
            }
            panelActions.hide();
            scheduleModel.update((modelValue) => {
                modelValue.isEnabled = false;
            });
        };
        this.harmonize = (shouldResetSchedule = true) => {
            this.dailyScheduleModel.setValue(this.dailyHarmonizationManager.harmonize(shouldResetSchedule));
            this.weeklyScheduleModel.setValue(this.weeklyHarmonizationManager.harmonize(shouldResetSchedule));
            this.monthlyScheduleModel.setValue(this.monthlyHarmonizationManager.harmonize(shouldResetSchedule));
            this.yearlyScheduleModel.setValue(this.yearlyHarmonizationManager.harmonize(shouldResetSchedule));
        };
        this.handleDailyPanelDone = (controlModelValue) => {
            const newModelValue = DailyScheduleModelsConverter_1.DailyScheduleModelsConverter.toMainModel(controlModelValue, this.dailyScheduleModel.getValue());
            this.dailyScheduleModel.setValue(Object.assign(Object.assign({}, newModelValue), { isModified: true }));
            this.harmonize();
            this.panelActions.dailySchedulePanelActions.hide();
        };
        this.handleWeeklyPanelDone = (controlModelValue) => {
            const newModelValue = WeeklyScheduleModelsConverter_1.WeeklyScheduleModelsConverter.toMainModel(controlModelValue, this.weeklyScheduleModel.getValue());
            this.weeklyScheduleModel.setValue(Object.assign(Object.assign({}, newModelValue), { isModified: true }));
            this.harmonize();
            this.panelActions.weeklySchedulePanelActions.hide();
        };
        this.handleMonthlyPanelDone = (controlModelValue) => {
            const newModelValue = MonthlyScheduleModelsConverter_1.MonthlyScheduleModelsConverter.toMainModel(controlModelValue, this.monthlyScheduleModel.getValue());
            this.monthlyScheduleModel.setValue(Object.assign(Object.assign({}, newModelValue), { isModified: true }));
            this.harmonize();
            this.panelActions.monthlySchedulePanelActions.hide();
        };
        this.handleYearlyPanelDone = (controlModelValue) => {
            const newModelValue = YearlyScheduleModelsConverter_1.YearlyScheduleModelsConverter.toMainModel(controlModelValue);
            this.yearlyScheduleModel.setValue(Object.assign(Object.assign({}, newModelValue), { isModified: true }));
            this.harmonize();
            this.panelActions.yearlySchedulePanelActions.hide();
        };
        this.handleDailyPanelCancel = () => {
            this.handlePanelCancel(this.dailyScheduleModel, this.panelActions.dailySchedulePanelActions);
        };
        this.handleShowDailyPanel = () => {
            this.panelActions.dailySchedulePanelActions.show({
                onDone: this.handleDailyPanelDone,
                onCancel: this.handleDailyPanelCancel,
            });
        };
        this.handleShowWeeklyPanel = () => {
            this.panelActions.weeklySchedulePanelActions.show({
                onDone: this.handleWeeklyPanelDone,
                onCancel: this.handleWeeklyPanelCancel,
            });
        };
        this.handleWeeklyPanelCancel = () => {
            this.handlePanelCancel(this.weeklyScheduleModel, this.panelActions.weeklySchedulePanelActions);
        };
        this.handleShowMonthlyPanel = () => {
            this.panelActions.monthlySchedulePanelActions.show({
                onDone: this.handleMonthlyPanelDone,
                onCancel: this.handleMonthlyPanelCancel,
                isArchiveEnabled: this.params.isArchiveEnabled,
            });
        };
        this.handleMonthlyPanelCancel = () => {
            this.handlePanelCancel(this.monthlyScheduleModel, this.panelActions.monthlySchedulePanelActions);
        };
        this.handleYearlyPanelCancel = () => {
            const scheduleModelValue = this.yearlyScheduleModel.getValue();
            if (scheduleModelValue.isModified) {
                this.panelActions.yearlySchedulePanelActions.hide();
                return;
            }
            this.panelActions.yearlySchedulePanelActions.hide();
            this.yearlyScheduleModel.update((modelValue) => {
                modelValue.isEnabled = false;
            });
        };
        this.handleShowYearlyPanel = () => {
            this.panelActions.yearlySchedulePanelActions.show({
                onDone: this.handleYearlyPanelDone,
                onCancel: this.handleYearlyPanelCancel,
                isArchiveEnabled: this.params.isArchiveEnabled,
                isArchiveRepositoryExisting: this.params.isArchiveEnabled,
            });
        };
        this.dailyScheduleModel = dailyScheduleModel;
        this.weeklyScheduleModel = weeklyScheduleModel;
        this.monthlyScheduleModel = monthlyScheduleModel;
        this.yearlyScheduleModel = yearlyScheduleModel;
        this.dailyScheduleForm = new core_1.Form(this.dailyScheduleModel);
        this.weeklyScheduleForm = new core_1.Form(this.weeklyScheduleModel);
        this.monthlyScheduleForm = new core_1.Form(this.monthlyScheduleModel);
        this.yearlyScheduleForm = new core_1.Form(this.yearlyScheduleModel);
        this.params = params;
        const scheduleModels = {
            dailyScheduleModel,
            weeklyScheduleModel,
            monthlyScheduleModel,
            yearlyScheduleModel,
        };
        this.dailyHarmonizationManager = new DailyScheduleHarmonizationManager_1.DailyScheduleHarmonizationManager(dailyScheduleModel, null, scheduleModels, dailyRetentionFieldsSettings);
        this.weeklyHarmonizationManager = new WeeklyScheduleHarmonizationManager_1.WeeklyScheduleHarmonizationManager(weeklyScheduleModel, null, scheduleModels, dailyRetentionFieldsSettings, weeklyRetentionFieldsSettings);
        this.monthlyHarmonizationManager = new MonthlyScheduleHarmonizationManager_1.MonthlyScheduleHarmonizationManager(monthlyScheduleModel, null, scheduleModels, monthlyRetentionFieldsSettings);
        this.yearlyHarmonizationManager = new YearlyScheduleHarmonizationManager_1.YearlyScheduleHarmonizationManager(yearlyScheduleModel, null, scheduleModels, yearlyRetentionFieldsSettings);
        this.dailyScheduleInfoItemsCreator = new DailyScheduleInfoItemsCreator_1.DailyScheduleInfoItemsCreator(labels.dailySchedule, texts, dailyScheduleModel);
        this.weeklyScheduleInfoItemsCreator = new WeeklyScheduleInfoItemsCreator_1.WeeklyScheduleInfoItemsCreator(labels.weeklySchedule, texts, weeklyScheduleModel);
        this.monthlyScheduleInfoItemsCreator = new MonthlyScheduleInfoItemsCreator_1.MonthlyScheduleInfoItemsCreator(labels.monthlySchedule, texts, monthlyScheduleModel);
        this.yearlyScheduleInfoItemsCreator = new YearlyScheduleInfoItemsCreator_1.YearlyScheduleInfoItemsCreator(labels.yearlySchedule, texts, {
            dailyScheduleModel,
            weeklyScheduleModel,
            monthlyScheduleModel,
            yearlyScheduleModel,
        }, yearlyRetentionFieldsSettings);
        this.panelActions = panelActions;
    }
    didActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.add(this.dailyScheduleModel.fieldChanges('isEnabled').subscribe(({ value }) => {
                this.harmonize(false);
                if (value) {
                    this.handleShowDailyPanel();
                }
            }));
            this.subscriptions.add(this.weeklyScheduleModel.fieldChanges('isEnabled').subscribe(({ value }) => {
                this.harmonize(false);
                if (value) {
                    this.handleShowWeeklyPanel();
                }
            }));
            this.subscriptions.add(this.monthlyScheduleModel.fieldChanges('isEnabled').subscribe(({ value }) => {
                this.harmonize(false);
                if (value) {
                    this.handleShowMonthlyPanel();
                }
            }));
            this.subscriptions.add(this.yearlyScheduleModel.fieldChanges('isEnabled').subscribe(({ value }) => {
                this.harmonize(false);
                if (value) {
                    this.handleShowYearlyPanel();
                }
            }));
            this.subscriptions.add(this.monthlyScheduleModel.fieldChanges('isArchiveEnabled').subscribe(({ value }) => {
                if (!value) {
                    this.harmonize();
                }
            }));
            this.subscriptions.add(this.yearlyScheduleModel.fieldChanges('isArchiveEnabled').subscribe(({ value }) => {
                if (!value) {
                    this.harmonize();
                }
            }));
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.unsubscribe();
        });
    }
}
exports.PolicyScheduleInteractor = PolicyScheduleInteractor;
//# sourceMappingURL=PolicyScheduleInteractor.js.map